import { render, staticRenderFns } from "./EditCostFactor.vue?vue&type=template&id=cd196a14&scoped=true&"
import script from "./EditCostFactor.vue?vue&type=script&lang=ts&"
export * from "./EditCostFactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd196a14",
  null
  
)

export default component.exports